import { render, staticRenderFns } from "./uploadLogPage.vue?vue&type=template&id=5afced88&scoped=true&"
import script from "./uploadLogPage.vue?vue&type=script&lang=js&"
export * from "./uploadLogPage.vue?vue&type=script&lang=js&"
import style0 from "./uploadLogPage.vue?vue&type=style&index=0&id=5afced88&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afced88",
  null
  
)

export default component.exports